import { render, staticRenderFns } from "./create-game.vue?vue&type=template&id=732f0ed0&scoped=true&"
import script from "./create-game.vue?vue&type=script&lang=js&"
export * from "./create-game.vue?vue&type=script&lang=js&"
import style0 from "./create-game.vue?vue&type=style&index=0&id=732f0ed0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732f0ed0",
  null
  
)

export default component.exports